module.exports = __webpack_public_path__ + "static/img/remove.4459921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/remove.png
// module id = fCZc
// module chunks = 0